import React from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { BeforeAfterSlider } from './BeforeAfterSlider';
import { images } from '../data/business';
const changes = ['New white plaster finish', 'Updated waterline tile', 'Travertine coping', 'New paver deck'];
export function Transformation() {
  return <section className="bg-white py-20 lg:py-28" aria-labelledby="transformation-title" data-id="element-320" data-mp="rmaf1gho7ih9">
      <div className="mx-auto grid max-w-7xl gap-10 px-5 lg:grid-cols-12 lg:items-center lg:gap-14 lg:px-8" data-id="element-321" data-mp="wl3ngui3ojak">
        <div className="lg:col-span-4" data-id="element-322" data-mp="11i3xfgi2m66y">
          <h2 id="transformation-title" className="section-title" data-id="element-323" data-mp="11h28c847zj68">
            See What the Right Renovation Can Do.
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-navy/70" data-id="element-324" data-mp="1ac8gveuvkfcg">
            From worn surfaces and outdated finishes to a pool ready to enjoy again.
          </p>

          <div className="mt-8 border-t border-line pt-6" data-id="element-325" data-mp="1f8yza8u5jn11">
            <p className="text-sm font-semibold text-navy" data-id="element-326" data-mp="1kaod1w8reest">What changed on this pool</p>
            <ul className="mt-4 space-y-3" data-id="element-327" data-mp="1c733sj9tm0fd">
              {changes.map(c => <li key={c} className="flex items-center gap-3 text-[15px] text-navy/80" data-id="element-328" data-mp="176fd5ypi7llo">
                  <CheckIcon className="h-4 w-4 shrink-0 text-aqua" aria-hidden="true" data-id="element-329" data-mp="134tvm020yj55" />
                  {c}
                </li>)}
            </ul>
          </div>

          <a href="#estimate" className="btn-primary mt-9 w-full sm:w-auto" data-id="element-330" data-mp="1uwi5mfxbytkt">
            Start Your Pool Transformation
            <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-331" data-mp="1quegiohqnqh2" />
          </a>
        </div>

        <div className="lg:col-span-8" data-id="element-332" data-mp="1m3xzyvimfoqh">
          <BeforeAfterSlider before={images.before} after={images.after} beforeAlt="Pool before renovation with stained plaster and worn coping" afterAlt="The same pool after renovation with new plaster, tile, and pavers" className="aspect-[4/3] md:aspect-[16/10]" data-id="element-333" data-mp="1m2myx3gk8v32" />
          <p className="mt-3 text-center text-sm text-navy/55" data-id="element-334" data-mp="29rxum6j1zzac">Drag the handle to compare</p>
        </div>
      </div>
    </section>;
}